import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-18",
  "use": "icon-icon-nav-18-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-18\"><path d=\"M512 476.8a35.072 35.072 0 0 0-35.2 35.2c0 19.52 15.68 35.2 35.2 35.2 19.52 0 35.2-15.68 35.2-35.2A35.072 35.072 0 0 0 512 476.8zM512 192C335.36 192 192 335.36 192 512s143.36 320 320 320 320-143.36 320-320-143.36-320-320-320z m70.08 390.08L320 704l121.92-262.08L704 320 582.08 582.08z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-18.svg
// module id = S+7H
// module chunks = 3